import React from "react";
import BusinessRelocationRfqsSuperAdminView from "../../components/logistics/BusinessRelocationRfqsSuperAdminView";

export default function BusinessRelocationRfqsManagementPage({
  basePath = "/super-admin",
}) {
  return <BusinessRelocationRfqsSuperAdminView basePath={basePath} />;
}
